import ModalBackButton from "@components/ModalBackButton";
import { useSavePushNotificationToken } from "@utils/notifications";
import { Stack } from "expo-router";
import { StatusBar } from "react-native";
import ErrorBoundaryComponent from "@components/ErrorBoundary";
import React, { useEffect } from "react";
import LoginGate from "@components/LoginGate";
import { useMe } from "@hooks/trpc/useMe";
import * as RudderStack from "@utils/rudderstack";
import * as CustomerIO from "@utils/customerio";
import { theme } from "@theme";
import LBox from "@components/LBox";
import { captureException } from "@utils/captureException";
import { getWelcomeSignupCreatedAt } from "@utils/analyticsIdentity";
import { useSentryProfile } from "./useSentryProfile";

export function ErrorBoundary(props: any) {
  return <ErrorBoundaryComponent {...props} level="app" />;
}
export const unstable_settings = {
  initialRouteName: "(tabs)",
};

const PushNotificationsTokenComponent = () => {
  useSavePushNotificationToken();

  return null;
};

const AnalyticsIdentifier = () => {
  const {
    query: { data: user, isPending },
  } = useMe();
  useSentryProfile();

  useEffect(() => {
    if (!user || isPending) {
      return;
    }

    const welcomeSignupCreatedAt = getWelcomeSignupCreatedAt(
      user.createdAtUnix,
    );

    console.log("::AnalyticsIdentifier - RudderStack identifying user");
    RudderStack.identify({
      userId: user.id,
      email: user.email,
      countryCode: user.plan?.countryId ?? user.countryCode,
      createdAt: welcomeSignupCreatedAt,
      plan_name: user.plan?.type ?? user.consumer?.subscription,
    }).catch((error) => {
      captureException(error, {
        channel: "breadcrumb",
        area: "analytics",
        operation: "identify-rudderstack-web",
      });
    });
    console.log("::AnalyticsIdentifier - CustomerIO identifying user");
    void CustomerIO.identify({
      userId: user.id,
      email: user.email,
      countryCode: user.plan?.countryId ?? user.countryCode,
      createdAt: welcomeSignupCreatedAt,
      plan_name: user.plan?.type ?? user.consumer?.subscription,
    });
  }, [user, isPending]);

  return null;
};

export default function AppLayout() {
  const initialRouteName = "(tabs)";
  const accessModalOptions = {
    animation: "slide_from_bottom" as const,
    presentation: "modal" as const,
    gestureEnabled: true,
  };

  return (
    <LoginGate>
      <StatusBar barStyle="light-content" />
      <PushNotificationsTokenComponent />
      <AnalyticsIdentifier />

      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: {
            backgroundColor: theme.colors.screenBg,
          },
        }}
        initialRouteName={initialRouteName}
      >
        <Stack.Screen name={initialRouteName} />
        <Stack.Screen name="[collectionType]/[collectionId]/index" />
        <Stack.Screen
          name="[collectionType]/[collectionId]/song/[songId]/credits"
          options={{
            presentation: "modal",
            headerShown: true,
            headerTitle: "",
            headerTitleAlign: "center",
            headerBackVisible: false,
            headerLeft: () => (
              <LBox pl="l3">
                <ModalBackButton />
              </LBox>
            ),
            headerTransparent: true,
            headerShadowVisible: false,
            headerTitleStyle: {
              color: "white",
            },
          }}
        />
        <Stack.Screen name="access/[accessId]" options={accessModalOptions} />

        <Stack.Screen
          name="access/[accessId]/tickets"
          options={accessModalOptions}
        />
        <Stack.Screen
          name="access/[accessId]/view-tickets"
          options={accessModalOptions}
        />
        <Stack.Screen
          name="access/[accessId]/my-order"
          options={accessModalOptions}
        />
        <Stack.Screen
          name="access/[accessId]/checkout"
          options={accessModalOptions}
        />
        <Stack.Screen
          name="access/[accessId]/live/[activityId]"
          options={accessModalOptions}
        />
      </Stack>
    </LoginGate>
  );
}
